import { TicketLayoutModel } from "../models/ticketLayoutModel";
import { Color } from "../style/colors";

function formatDate(date: Date) {
  var year = date.getFullYear().toString();
  var month = (date.getMonth() + 101).toString().substring(1);
  var day = (date.getDate() + 100).toString().substring(1);
  return day + "/" + month + "/" + year;
}

export const ticketLayouts: TicketLayoutModel[] = [
  {
    eventName: {
      hintText: "Event Name",
      color: Color().whiteColor,
      fontSize: "min(4vw, 30px)",
      staticFontSize: "30px",
      fontWeight: "bold",
      order: 0,
      key: "eventName",
    },
    fullNameAndId: {
      hintText: "Full Name #id",
      color: Color().whiteColor,
      fontSize: "min(3vw, 16px)",
      staticFontSize: "16px",
      fontWeight: "bold",
      order: 1,
      key: "fullNameAndId",
    },
    description: {
      hintText: "Description",
      color: Color().whiteColor,
      fontSize: "min(3vw, 16px)",
      staticFontSize: "16px",
      fontWeight: "",
      order: 2,
      key: "description",
    },
    date: {
      hintText: formatDate(new Date(Date.now())),
      color: Color().whiteColor,
      fontSize: "min(2.5vw, 18px)",
      staticFontSize: "18px",
      fontWeight: "",
      order: 3,
      key: "date",
    },
  },
  {
    eventName: {
      hintText: "Event Name",
      color: Color().whiteColor,
      fontSize: "min(4vw, 30px)",
      staticFontSize: "30px",
      fontWeight: "bold",
      order: 0,
      key: "eventName",
    },
    fullNameAndId: {
      hintText: "Full Name #id",
      color: Color().whiteColor,
      fontSize: "min(3vw, 16px)",
      staticFontSize: "16px",
      fontWeight: "bold",
      order: 3,
      key: "fullNameAndId",
    },
    description: {
      hintText: "Description",
      color: Color().whiteColor,
      fontSize: "min(3vw, 16px)",
      staticFontSize: "16px",
      fontWeight: "",
      order: 2,
      key: "description",
    },
    date: {
      hintText: formatDate(new Date(Date.now())),

      color: Color().whiteColor,
      fontSize: "min(2.5vw, 18px)",
      staticFontSize: "18px",
      fontWeight: "",
      order: 1,
      key: "date",
    },
  },
  {
    eventName: {
      hintText: "Event Name",
      color: Color().whiteColor,
      fontSize: "min(4vw, 30px)",
      staticFontSize: "30px",
      fontWeight: "bold",
      order: 0,
      key: "eventName",
    },
    fullNameAndId: {
      hintText: "Full Name #id",
      color: Color().whiteColor,
      fontSize: "min(3vw, 16px)",
      staticFontSize: "16px",
      fontWeight: "bold",
      order: 2,
      key: "fullNameAndId",
    },
    description: {
      hintText: "Description",
      color: Color().whiteColor,
      fontSize: "min(3vw, 16px)",
      staticFontSize: "16px",
      fontWeight: "",
      order: 1,
      key: "description",
    },
    date: {
      hintText: formatDate(new Date(Date.now())),

      color: Color().whiteColor,
      fontSize: "min(2.5vw, 18px)",
      staticFontSize: "18px",
      fontWeight: "",
      order: 3,
      key: "date",
    },
  },
  {
    eventName: {
      hintText: "Event Name",
      color: Color().whiteColor,
      fontSize: "min(4vw, 30px)",
      staticFontSize: "30px",
      fontWeight: "bold",
      order: 1,
      key: "eventName",
    },
    fullNameAndId: {
      hintText: "Full Name #id",
      color: Color().whiteColor,
      fontSize: "min(3vw, 16px)",
      staticFontSize: "16px",
      fontWeight: "bold",
      order: 0,
      key: "fullNameAndId",
    },
    description: {
      hintText: "Description",
      color: Color().whiteColor,
      fontSize: "min(3vw, 16px)",
      staticFontSize: "16px",
      fontWeight: "",
      order: 2,
      key: "description",
    },
    date: {
      hintText: formatDate(new Date(Date.now())),

      color: Color().whiteColor,
      fontSize: "min(2.5vw, 18px)",
      staticFontSize: "18px",
      fontWeight: "",
      order: 3,
      key: "date",
    },
  },
];
